
  import React, { Component } from "react";
  import { Link } from "react-router-dom";
  import { Segment, List, Input, Form, Header,  Checkbox, Select, Divider, Tab} from 'semantic-ui-react'
  import { invokeApig } from "../libs/awsLib";
  import { defaultJSONObject } from "../libs/sharedFunctions";
import { strict } from "assert";
import { SSL_OP_TLS_BLOCK_PADDING_BUG } from "constants";

  export default class XMLDataEntry extends Component {

      constructor(props) {
        super(props);
        
        this.state = {
            xml: ''
        };
        // this.updateAddress=this.updateAddress.bind(this);
      }   

     
    componentDidMount()
    {
      // const xml=this.buildXML(this.props.jsonformat, '', 0, {});
      const xml="<"+this.props.namespace+":"+this.props.jsonformat.name+"/>"
      this.setState({xml: xml})
      this.props.onDataChange(xml)
    }

    componentWillReceiveProps(nextProps)
    {
      if(this.props.jsonformat!==nextProps.jsonformat)
      {
        const xml="<"+this.props.namespace+":"+nextProps.jsonformat.name+"/>"
        this.setState({xml: xml})
        this.props.onDataChange(xml)
          
      }
    }

    buildXML(object, key, index, updateValues)
    {
      var fields;
      var value;
      var childXml='';
      var returnXml='';
      if (object.type==='object')
      {
        for (var occurence=1;occurence<=object.maxoccurs; occurence++)
        {
        childXml='';
        object.fields.map((field, i)=>{
          
          childXml=childXml+this.buildXML(field, key+'_'+object.name+occurence, i, updateValues)
          
        })
        var attr=''
        if (object.indexed) 
          attr=' index="'+occurence+'"'
        if (childXml.length>0)
        returnXml+='<'+this.props.namespace+':'+object.name+attr+'>'+childXml+'</'+this.props.namespace+':'+object.name +'>'
      }
      return returnXml;        
      }
      else if (object.type==='sequence')
      {
        object.fields.map((field, i)=>{
          
          childXml=childXml+this.buildXML(field, key, i, updateValues)
          
        })
        return childXml
        
      }
      if (object.type==='choice')
      {
        //get selected choice
        const choicekey='data_'+key+'_choice'+index.toString();
        var choicevalue=null;
        console.log(choicekey)
        if (choicekey in updateValues)
          choicevalue=updateValues[choicekey]
        else if (choicekey in this.state)
          choicevalue=this.state[choicekey]
        else
          choicevalue=0
        const selectedchoice=object.fields[choicevalue]

        

        childXml=this.buildXML(selectedchoice, key, choicevalue, updateValues)

        console.log(selectedchoice, key, choicevalue, childXml)

        // if (childXml.length>0)
        //   return '<'+name+'>'+childXml+'</'+object.name +'>'
        // else
        //   return '<'+name+ '/>'
        return childXml;
      }        
      else if (object.type==='null')
        return '<'+this.props.namespace+':'+object.name+ '/>'
      else 
      {
        //return all field
        for (var occurence=1;occurence<=object.maxoccurs; occurence++)
        {       
        var attr=''
        if (object.indexed) 
          attr=' index="'+occurence+'"'
        const fieldkey='data_'+key+'_'+object.name+occurence;
        if (fieldkey in updateValues)
        {
          returnXml+= '<'+this.props.namespace+':'+object.name+attr+'>'+updateValues[fieldkey]+'</'+this.props.namespace+':'+object.name +'>'
        }
        else if (fieldkey in this.state)
        {
          returnXml+='<'+this.props.namespace+':'+object.name+attr+'>'+this.state[fieldkey]+'</'+this.props.namespace+':'+object.name +'>'
        }
      }
      return returnXml
      }

    }

    render() {

      
      const updateData=(updateValues)=>
      {
        this.setState(updateValues)
        const xml=this.buildXML(this.props.jsonformat, '', 0, updateValues);
        this.setState({xml: xml})
        this.props.onDataChange(xml)
        }



      const renderField=(field, key, i)=>
      {
        var renderfield;
        const fieldname=field['name'];
        const fieldkey='data_'+key+'_'+fieldname+i;
        var value=null;
        if (fieldkey in this.state)
          value=this.state[fieldkey]
        

        if ('lookupvalues' in field)
        {
          const options=field.lookupvalues.map(value=>{return {key: value, value: value, text: value }})
          renderfield=<Select key={fieldkey} placeholder={field.label} className="inputfield" disabled={!this.props.editmode} options={options} value={value} onChange={(event, data)=>{updateData({[fieldkey]: data.value})}}/>
        }
        else
        {
          if (field.type==='varchar')
            renderfield=<Input key={fieldkey} placeholder={field.label} className="inputfield" disabled={!this.props.editmode} type='text' maxLength={field.length} value={value} onChange={(event, data)=>{updateData({[fieldkey]: data.value})}}/> 
          else if (field.type==='int')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='number' step="1" disabled={!this.props.editmode} maxLength={field.length} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateData({[fieldkey]: data.value})}}/> 
          else if (field.type==='decimal')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='number' disabled={!this.props.editmode} step={Math.pow(10, -field.scale)} maxLength={field.precision} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateData({[fieldkey]: data.value})}}/> 
          else if (field.type==='date')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='date' disabled={!this.props.editmode} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateData({[fieldkey]: data.value})}}/> 
          else if (field.type==='datetime')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='datetime-local' disabled={!this.props.editmode} className="inputfield" maxLength={field.length} value={value ? value.slice(0, -7) : null} onChange={(event, data)=>{updateData({[fieldkey]: data.value+':00.00Z'})}}/> 
            else if (field.type==='time')
            renderfield=<Input key={fieldkey} placeholder={field.label} type='time' disabled={!this.props.editmode} className="inputfield" maxLength={field.length} value={value} onChange={(event, data)=>{updateData({[fieldkey]: data.value+':00'})}}/> 

            else if (field.type==='boolean')
            renderfield=<Checkbox key={fieldkey} label={field.label} disabled={!this.props.editmode} className="inputfield" value={value} onChange={(event, data)=>{updateData({[fieldkey]: data.checked ? 'true':'false'})}}/>
          }
          if (renderfield)
          {
            return <Form.Field>
              {(field.type!=='boolean') ? <label>{field.label}</label> : null}
              {renderfield}
            </Form.Field>
          }
      }
    


      const renderObject=(jsondef, key, index)=>
      {
      

            if (jsondef.type==='object')
            {
              var objects=[];
              for (var i=1;i<=jsondef.maxoccurs; i++)
              {
                objects.push(<Segment>
                <Form>
                    <Header as='h5'><label>{jsondef['label']+'  '}</label></Header>
                {'fields' in jsondef && jsondef.fields.map((field, j)=>
                {
                  return renderObject(field, key+'_'+jsondef['name']+i, j);

                })}
                </Form>
                </Segment>)
              }  
              return objects;
            }
            else if (jsondef.type==='choice')
            {
              var choiceid=0;
              const choicekey='data_'+key+'_choice'+index.toString();
              if (!(choicekey in this.state))
              {
                this.setState({[choicekey]: 0})
              }
              else
              {
                choiceid=this.state[choicekey]
              }
              const choice=jsondef.fields[choiceid]
              var renderChoice=renderObject(choice, key, choiceid)

              return <Form>
                <Form.Group inline>
                  {jsondef.fields.map((loopchoice, loopid)=>{
                    return <Form.Checkbox radio checked={loopid===choiceid} label={loopchoice.label} name={key+'_choice'+loopid} onChange={(event, data)=>{if (data.checked) updateData({[choicekey]: loopid})}}/>
                  })
                  }
                  </Form.Group>
                  {renderChoice}
              </Form>

            }

            else if (jsondef.type==='sequence')
            {
                return jsondef.fields.map((field, i)=>
                {
                  return renderObject(field, key, i);
                })
            }
            else 
            {
                //must be a field
                var fields=[];  
                for (var i=1;i<=jsondef.maxoccurs; i++)
                  fields.push(renderField(jsondef, key, i))
                return fields

            }


      }

      return (
        <Segment>
            {renderObject(this.props.jsonformat, '')}
            {/* {this.state.xml} */}
        </Segment>

      );
    }
  }